import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=3dba1e5d&scoped=true&"
import script from "./ChoosePlan.vue?vue&type=script&lang=js&"
export * from "./ChoosePlan.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=3dba1e5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba1e5d",
  null
  
)

export default component.exports